import { Link } from 'react-router-dom'
import styled from 'styled-components'
import useFetchChatRoom from '../pages/contract/hooks/useFetchChatRoom'
import { Contract } from '../schema/contract'

interface ChatFloatingButtonProps {
  to: string
  contract?: Contract
}

const FloatingButtonContainer = styled(Link)`
  position: fixed;
  bottom: 24px;
  right: 24px;
  z-index: 100;
  text-decoration: none;

  @media only screen and (max-width: ${(p) => p.theme.vp}px) {
    bottom: 16px;
    right: 0;
  }
`

const Button = styled.button<{ hasUnread?: boolean }>`
  display: flex;
  width: 160px;
  height: 40px;
  min-width: 40px;
  padding: 0 16px;
  justify-content: center;
  align-items: center;
  gap: 4px;
  border-radius: 9999px;
  border: 1px solid ${(p) => p.theme.MAIN_BORDER_V2};
  background: ${(p) => p.theme.MAIN_BACKGROUND_V2};
  color: black;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  box-shadow: 0 10px 15px -5px rgba(10, 10, 10, 0.1),
    0 5px 5px -2px rgba(10, 10, 10, 0.05);
  transition: all 0.2s ease;
  position: relative;

  &:hover {
    background-color: ${(p) => p.theme.MAIN_V2};
    box-shadow: 0 10px 15px -5px rgba(10, 10, 10, 0.15),
      0 5px 5px -2px rgba(10, 10, 10, 0.08);
  }

  @media only screen and (max-width: ${(p) => p.theme.vp}px) {
    width: 64px;
    height: 64px;
    min-width: 40px;
    padding: 0 16px;
    justify-content: center;
    border-radius: 9999px 0 0 9999px;
    border-top: 1px solid ${(p) => p.theme.MAIN_BORDER_V2};
    border-bottom: 1px solid ${(p) => p.theme.MAIN_BORDER_V2};
    border-left: 1px solid ${(p) => p.theme.MAIN_BORDER_V2};
    border-right: none;
  }
`

const ChatIcon = styled.div<{ hasUnread?: boolean }>`
  width: 24px;
  height: 24px;
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
  background-image: url('/image/${(p) =>
    p.hasUnread ? 'chat-unread' : 'chat'}.svg');
  flex-shrink: 0;

  @media only screen and (max-width: ${(p) => p.theme.vp}px) {
    width: 32px;
    height: 32px;
  }
`

const ButtonText = styled.span`
  color: #463e28;
  text-align: center;
  font-family: 'Noto Sans JP', sans-serif;
  font-size: 14px;
  font-style: normal;
  font-weight: 700;
  line-height: 20px;
  white-space: nowrap;
  flex: 1 0 0;

  @media only screen and (max-width: ${(p) => p.theme.vp}px) {
    display: none;
  }
`

const ChatFloatingButton = ({ to, contract }: ChatFloatingButtonProps) => {
  const { unreadCnt } = useFetchChatRoom(contract, false)

  // 先物（Feature）の場合や、ownerIdがない場合はチャットボタンを表示しない
  if (!contract?.ownerId || !contract?.agentId) {
    return null
  }

  return (
    <FloatingButtonContainer to={to}>
      <Button hasUnread={!!unreadCnt}>
        <ChatIcon hasUnread={!!unreadCnt} />
        <ButtonText>チャット</ButtonText>
      </Button>
    </FloatingButtonContainer>
  )
}

export default ChatFloatingButton
